import {useEffect, useState} from 'react'
import {useForm} from "react-hook-form"
import InputWithLabel from 'elements/InputWithLabel'
import ButtonBigWithAction from 'elements/ButtonBigWithAction'
import LoadingIndicator from 'pages/LoadingIndicator'
import PutRequest from 'components/PutRequest'
import { useSanctum } from "react-sanctum";

const Password = () => {

    const { user } = useSanctum();

    const {register, handleSubmit, reset, formState: { errors }, setValue, getValues} = useForm({
        defaultValues: {
            current_password: null,
            password: null,
            password_confirmation: null,
        }
    })

    const inputs = [
        {
            key: "passwordInput1",
            type: "password",
            name: "current_password",
            placeholder: "Zorunlu Alan",
            label: "Mevcut Şifre *",
            register: register,
            validator: {
                required: "Bu alan zorunludur.", 
                minLength: {value: 8, 
                            message: "En az 8 karakter olmalı"}, 
                maxLength: {value: 24, 
                            message:"En fazla 24 karakter olmalı"}
            },
            error: errors?.current_password?.message 
        },
        {
            key: "passwordInput2",
            type: "password",
            name: "password",
            placeholder: "Zorunlu Alan",
            label: "Yeni Şifre *",
            register: register,
            validator: {
                required: "Bu alan zorunludur.", 
                minLength: {value: 8, 
                            message: "En az 8 karakter olmalı"}, 
                maxLength: {value: 24, 
                            message:"En fazla 24 karakter olmalı"}
            },
            error: errors?.password?.message 
        },
        {
            key: "passwordInput3",
            type: "password",
            name: "password_confirmation",
            placeholder: "Zorunlu Alan",
            label: "Yeni Şifre Tekrar *",
            register: register,
            validator: {
                validate: (value) => value === getValues("password") || "Girdiğiniz şifreler eşleşmiyor."
            },
            error: errors?.password_confirmation?.message 
        },
    ]

    const [saveStatus, setSaveStatus] = useState()
    const [loading, setLoading] = useState(false)

    const handleForm = (data) => {
        setLoading(true)
        PutRequest('api/user/'+user.id+'/password', data)
            .then(response => {
                
                const successMessage = (
                    <div className='text-sm text-green-100 bg-green-600 text-bold mb-2 p-1'>
                        <p>Şifreniz başarıyla değiştirildi. Sisteme bir dahaki sefere yeni şifrenizle giriş yapabilirsiniz.</p> 
                    </div>
                )
                setSaveStatus(successMessage)
                reset()
                setLoading(false)
            })
            .catch(error => {
                const err = error.response.data.errors
                if(err) {
                    const errorItems = Object.keys(err).map((value, index) => {
                        return (
                            <li key={value.toString()}>{err[value][0]}</li>
                        )
                    })
                    const errorMessage = (
                        <div className='text-sm text-red-600'>
                            <p>{error.response.data.message}</p>   
                            <ul className='list-[circle] list-inside'>
                                {errorItems}
                            </ul>                     
                        </div>
                    )
                    setSaveStatus(errorMessage)
                } else {
                    const errorMessage = (
                        <div className='text-sm text-red-100 bg-red-600 text-bold mb-2 p-1'>
                            <p>{`${error.response.statusText} (${error.response.status})`}</p> 
                        </div>
                    )   
                    
                    setSaveStatus(errorMessage)
                }  
                setLoading(false)
            })
    }
    return (
        <div className='lg:grid lg:grid-cols-2 lg:gap-8'>
            <div className='text-left mt-12'>
                <h2 className='text-2xl font-semibold text-gray-700 my-4 '>Şifre Güncelleme</h2>
                <p className='text-md text-gray-700'> Bu alandan sistemde kayıtlı olan şifrenizi güncelleyebilirsiniz.</p>
            </div>
            <div className='text-left'>
                    <div className='h-12'>
                        {saveStatus}
                    </div>
                    <form onSubmit={handleSubmit(handleForm)}>
                    {inputs.map((input, index) => {
                                return (
                                    <div className='max-w-[400px]' key={`inputContainer${index}`}>                                    
                                            <InputWithLabel {...input} addClass="mt-2"/>
                                    </div>
                                )
                            })  }
                        <ButtonBigWithAction type="submit" addClass="text-white bg-emerald-500 w-full max-w-[400px]" title="Kaydet" />
                    </form>
                </div>
                {loading && <LoadingIndicator />}
                    
        </div>
    )
}

export default Password